import api from './api';

// Helper function to check authentication
const checkAuth = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required. Please sign in.');
  }
  return token;
};

export const getStockInfo = async (stockCode, dateFrom, dateEnd) => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.get('/api/data_predator/get-stock-info/', {
      params: {
        stock_code: stockCode,
        date_from: dateFrom,
        date_end: dateEnd,
      },
    });

    const data = response.data.data;

    // 데이터 변환 - Chakra UI 버전과 동일한 형식으로 변환
    const transformedData = data.map(item => ({
      date: item.Date,
      open: item.Open,
      high: item.High,
      low: item.Low,
      close: item.Close,
      volume: item.Volume,
    }));

    return transformedData;
  } catch (error) {
    console.error('Failed to fetch stock info', error);
    throw error;
  }
};

export const getAllStocks = async () => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.get('/api/data_predator/stocks/');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch all stocks', error);
    throw error;
  }
};

export const getAllAccounts = async () => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.get('/api/data_predator/accounts/');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch all accounts', error);
    throw error;
  }
};

export const getStockName = async (symbol) => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.get('/api/data_predator/get-stock-name/', {
      params: {
        symbol: symbol,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch stock name', error);
    throw error;
  }
};

export const getUniqueStocksFromDailyPrices = async (filters = {}) => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.get('/api/data_predator/unique-stocks-from-daily-prices/', {
      params: filters,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch unique stocks from daily prices', error);
    throw error;
  }
};

export const searchStocksByName = async (query, limit = 20) => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.get('/api/data_predator/search-stocks/', {
      params: {
        query: query,
        limit: limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Failed to search stocks by name', error);
    throw error;
  }
};

export const addStockFromSearch = async (stockCode, stockName, isSafeAsset = false) => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.post('/api/data_predator/add-stock/', {
      stock_code: stockCode,
      stock_name: stockName,
      is_safe_asset: isSafeAsset,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to add stock from search', error);
    throw error;
  }
};

export const createStock = async (stockSymbol, stockName, isSafeAsset = false) => {
  try {
    checkAuth(); // Check authentication before making API call
    
    const response = await api.post('/api/data_predator/stocks/', {
      stock_symbol: stockSymbol,
      stock_name: stockName,
      is_safe_asset: isSafeAsset,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to create stock', error);
    throw error;
  }
};
